import { Stack } from "@mui/material";
import GeneralTable from "components/datadisplay/table/GeneralTable";
import { TopUsersLoader } from "components/loaders/TopUserLoaders";
import { useEffect } from "react";
import useFetch from "services/hooks/useFetch";
import { ApiUrls } from "services/utils/globalVariables";

export default function TopCustomerPage() {

    const [{ response, isLoading, error }, doFetch] = useFetch(ApiUrls.GetTopUser, "get")

    useEffect(() => {
        doFetch()
    }, [])

    return (
        <Stack sx={{direction: "ltr !important"}}>
            <Stack spacing={1} >
                {
                    isLoading ? 
                        <GeneralTable 
                            data={response.Data} 
                            section="topCustomer"
                        />
                    : <TopUsersLoader />
                }
            </Stack>
        </Stack>
    )
}